import type { WorkspaceLoader, WorkspaceModuleConfig } from './WorkspaceLoader';

export type StylesConfig = {
	class?: string;
	name?: string;
	tags?: string[];
};

export class WorkspaceConfig {
	public static readonly $inject = ['mx.sb.WorkSpaceLoader.Loader'];
	constructor(private readonly workspaceLoader: WorkspaceLoader) {}

	private _customStyles: StylesConfig[] = [];
	public modules = Object.assign([], {
		add: (name: string, config: WorkspaceModuleConfig) => {
			this.workspaceLoader.createModule(name, config);
			this.workspaceLoader.registerModule(name);
		},
	});

	public get customStyles() {
		return this._customStyles;
	}

	public registerModule(name: string) {
		return this.workspaceLoader.registerModule(name);
	}

	public registerStyles(styleConfigs: StylesConfig[] = []) {
		const errorMessage = 'registerStyles: an attribute should be an array each item of which should be an object { class: String, name: String, tags: String[] }';
		if (!Array.isArray(styleConfigs)) {
			throw new Error(errorMessage);
		}
		styleConfigs.forEach((config) => {
			if (
				!config ||
				typeof config !== 'object' ||
				typeof config.class !== 'string' ||
				!config.class.length ||
				typeof config.name !== 'string' ||
				!config.name.length ||
				!Array.isArray(config.tags) ||
				!config.tags.length
			) {
				throw new Error(errorMessage);
			}

			this._customStyles.push(config);
		});
	}
}
